// customer/customer.schema.ts
import { z } from "zod";
var SalesRepSchema = z.object({
  salesRepId: z.number(),
  name: z.string(),
  email: z.string().email()
});
var B2BWaveSalesRepSchema = z.object({
  sales_rep_id: z.number(),
  name: z.string(),
  email: z.string().email()
});
var B2BWaveCustomerSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  created_at: z.string(),
  updated_at: z.string(),
  approved: z.boolean(),
  company_name: z.string(),
  name: z.string(),
  company_activities: z.string(),
  pricelist_id: z.number(),
  is_active: z.boolean(),
  disable_ordering: z.boolean(),
  phone: z.string(),
  comments_admin: z.string().nullable(),
  vat_group_id: z.number(),
  company_activity_id: z.number(),
  discount_percentage: z.string(),
  reference_code: z.string().nullable(),
  sales_rep_id: z.number().nullable(),
  sales_rep_commission: z.string(),
  minimum_order_value: z.string(),
  address: z.string(),
  city: z.string(),
  province: z.string(),
  country: z.string(),
  postal_code: z.string(),
  website: z.string().nullable(),
  tax_id: z.string(),
  tax_office: z.string().nullable(),
  phone2: z.string().nullable(),
  fax: z.string().nullable(),
  invoice_same: z.boolean(),
  invoice_phone: z.string().nullable(),
  invoice_email: z.string().nullable(),
  invoice_address: z.string().nullable(),
  invoice_city: z.string().nullable(),
  invoice_province: z.string().nullable(),
  invoice_country: z.string().nullable(),
  invoice_tax_id: z.string().nullable(),
  invoice_tax_office: z.string().nullable(),
  invoice_postal_code: z.string().nullable(),
  company_number: z.string(),
  extra_fields: z.record(z.unknown()),
  address2: z.string().nullable(),
  invoice_address2: z.string().nullable(),
  email_new_orders_attach_xls: z.boolean(),
  enable_product_feed: z.boolean(),
  enable_api: z.boolean(),
  enable_orders_import: z.boolean(),
  receive_email_notification: z.boolean(),
  sales_reps: z.array(B2BWaveSalesRepSchema),
  payment_ways: z.array(z.string()),
  can_confirm_order: z.boolean().nullable()
});
var CreateB2BWaveCustomerInputSchema = B2BWaveCustomerSchema.partial().extend({
  email: z.string().email(),
  company_name: z.string(),
  name: z.string(),
  vat_group_id: z.number(),
  pricelist_id: z.number(),
  can_confirm_order: z.boolean().default(false)
});
var CreateCustomerSchema = CreateB2BWaveCustomerInputSchema;
var GetB2BWaveCustomersInputSchema = z.object({
  id_eq: z.number().optional(),
  email_eq: z.string().optional(),
  company_name_eq: z.string().optional(),
  name_eq: z.string().optional(),
  pricelist_id_eq: z.number().optional(),
  email_cont: z.string().optional(),
  company_name_cont: z.string().optional(),
  name_cont: z.string().optional()
});
var CustomerSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  createdAt: z.date(),
  updatedAt: z.date(),
  approved: z.boolean(),
  companyName: z.string(),
  name: z.string(),
  companyActivities: z.string(),
  pricelistId: z.number(),
  isActive: z.boolean(),
  disableOrdering: z.boolean(),
  phone: z.string(),
  commentsAdmin: z.string().nullable(),
  vatGroupId: z.number(),
  companyActivityId: z.number(),
  discountPercentage: z.string(),
  referenceCode: z.string().nullable(),
  salesRepId: z.number().nullable(),
  salesRepCommission: z.string(),
  minimumOrderValue: z.string(),
  address: z.string(),
  city: z.string(),
  province: z.string(),
  country: z.string(),
  postalCode: z.string(),
  website: z.string().nullable(),
  taxId: z.string(),
  taxOffice: z.string().nullable(),
  phone2: z.string().nullable(),
  fax: z.string().nullable(),
  invoiceSame: z.boolean(),
  invoiceEmail: z.string().nullable(),
  invoicePhone: z.string().nullable(),
  invoiceAddress: z.string().nullable(),
  invoiceCity: z.string().nullable(),
  invoiceProvince: z.string().nullable(),
  invoiceCountry: z.string().nullable(),
  invoiceTaxId: z.string().nullable(),
  invoiceTaxOffice: z.string().nullable(),
  invoicePostalCode: z.string().nullable(),
  companyNumber: z.string(),
  extraFields: z.record(z.unknown()),
  address2: z.string().nullable(),
  invoiceAddress2: z.string().nullable(),
  emailNewOrdersAttachXls: z.boolean(),
  enableProductFeed: z.boolean(),
  enableApi: z.boolean(),
  enableOrdersImport: z.boolean(),
  receiveEmailNotification: z.boolean(),
  salesReps: z.array(SalesRepSchema),
  paymentWays: z.array(z.string())
});
var CustomerDtoSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  createdAt: z.string(),
  updatedAt: z.string(),
  approved: z.boolean(),
  companyName: z.string(),
  name: z.string(),
  companyActivities: z.string(),
  pricelistId: z.number(),
  isActive: z.boolean(),
  disableOrdering: z.boolean(),
  phone: z.string(),
  commentsAdmin: z.string().nullable(),
  vatGroupId: z.number(),
  companyActivityId: z.number(),
  discountPercentage: z.string(),
  referenceCode: z.string().nullable(),
  salesRepId: z.number().nullable(),
  salesRepCommission: z.string(),
  minimumOrderValue: z.string(),
  address: z.string(),
  city: z.string(),
  province: z.string(),
  country: z.string(),
  postalCode: z.string(),
  website: z.string().nullable(),
  taxId: z.string(),
  taxOffice: z.string().nullable(),
  phone2: z.string().nullable(),
  fax: z.string().nullable(),
  invoiceSame: z.boolean(),
  invoiceEmail: z.string().nullable(),
  invoicePhone: z.string().nullable(),
  invoiceAddress: z.string().nullable(),
  invoiceCity: z.string().nullable(),
  invoiceProvince: z.string().nullable(),
  invoiceCountry: z.string().nullable(),
  invoiceTaxId: z.string().nullable(),
  invoiceTaxOffice: z.string().nullable(),
  invoicePostalCode: z.string().nullable(),
  companyNumber: z.string(),
  extraFields: z.record(z.unknown()),
  address2: z.string().nullable(),
  invoiceAddress2: z.string().nullable(),
  emailNewOrdersAttachXls: z.boolean(),
  enableProductFeed: z.boolean(),
  enableApi: z.boolean(),
  enableOrdersImport: z.boolean(),
  receiveEmailNotification: z.boolean(),
  salesReps: z.array(SalesRepSchema),
  paymentWays: z.array(z.string())
});
var B2BWaveCustomerDtoSchema = CustomerDtoSchema.extend({
  isSmsCapable: z.boolean().optional().nullable(),
  canConfirmOrder: z.boolean().optional().nullable()
});
var CreateCustomerDtoSchema = CustomerDtoSchema.partial().extend({
  email: z.string().email(),
  companyName: z.string(),
  name: z.string(),
  vatGroupId: z.number(),
  pricelistId: z.number(),
  canConfirmOrder: z.boolean().default(false)
});
var GetB2BWaveCustomersInputDtoSchema = z.object({
  idEq: z.number().optional(),
  emailEq: z.string().optional(),
  companyNameEq: z.string().optional(),
  nameEq: z.string().optional(),
  pricelistIdEq: z.number().optional(),
  emailCont: z.string().optional(),
  companyNameCont: z.string().optional(),
  nameCont: z.string().optional()
});
var CreateCustomerMinimalDtoSchema = z.object({
  email: z.string().email(),
  companyName: z.string(),
  name: z.string(),
  companyActivities: z.string(),
  paymentWays: z.array(z.string()),
  pricelistId: z.number(),
  phone: z.string(),
  address: z.string(),
  city: z.string(),
  province: z.string(),
  country: z.string(),
  postalCode: z.string(),
  website: z.string().nullable().optional(),
  taxId: z.string(),
  vatGroupId: z.number(),
  companyNumber: z.string(),
  extraFields: z.record(z.unknown()).optional(),
  address2: z.string().nullable().optional(),
  approved: z.boolean().optional(),
  disableOrdering: z.boolean().optional()
});
var CreateAuthenticatedCustomerDtoSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  companyName: z.string(),
  name: z.string(),
  phone: z.string(),
  address: z.string(),
  city: z.string(),
  postalCode: z.string().optional(),
  website: z.string().nullable().optional(),
  taxId: z.string().optional(),
  companyNumber: z.string(),
  extraFields: z.record(z.unknown()).optional(),
  address2: z.string().nullable().optional(),
  paymentWays: z.array(z.string()),
  companyActivities: z.string()
});
var AuthCustomerDtoSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  companyName: z.string(),
  companyNumber: z.string(),
  name: z.string(),
  phone: z.string(),
  address: z.string(),
  city: z.string(),
  paymentWays: z.array(z.string()),
  companyActivities: z.string(),
  role: z.string()
});
export {
  AuthCustomerDtoSchema,
  B2BWaveCustomerDtoSchema,
  B2BWaveCustomerSchema,
  B2BWaveSalesRepSchema,
  CreateAuthenticatedCustomerDtoSchema,
  CreateB2BWaveCustomerInputSchema,
  CreateCustomerDtoSchema,
  CreateCustomerMinimalDtoSchema,
  CreateCustomerSchema,
  CustomerDtoSchema,
  CustomerSchema,
  GetB2BWaveCustomersInputDtoSchema,
  GetB2BWaveCustomersInputSchema,
  SalesRepSchema
};
